import API from './Api'
import { getToken } from '../Session/Session'

const endpointBaseUrl = 'orders';

class OrdersService {
    baseUrl(){
        return endpointBaseUrl;
    }

    getOrders() {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
        return API.get(endpointBaseUrl);
    }

    createOrder(order) {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
        return API.post(endpointBaseUrl + "/create", order);
    }

    acceptOrder(orderId) {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
        return API.get(endpointBaseUrl + "/acceptorder/" + orderId);
    }

    cancelOrder(orderId) {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
        return API.get(endpointBaseUrl + "/cancelorder/" + orderId);
    }

    getOrderStatus(orderId) {
        API.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
        return API.get(endpointBaseUrl + "/getorderstatus/" + orderId);
    }
}

export default new OrdersService();